import { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import { Layout } from './components/Layout';
import { getCurrentApplicationUser } from './api/applicationApi';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'react-tooltip/dist/react-tooltip.css'
import './custom.css';
import GetAppRoutes from './AppRoutes';
import { ToastContainer } from 'react-toastify';

export default function App() {
  const displayName = App.name;

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isAppLoading, setIsAppLoading] = useState<boolean>(true);

  const tryLoadCurrentUser = async() => {
    try {
        let user = await getCurrentApplicationUser();
        setIsAuthenticated(user.isAuthenticated);
    } 
    catch (error) {
        setIsAuthenticated(false);
    }
    finally {
      setIsAppLoading(false);
    }
  };

  useEffect(() => {
    tryLoadCurrentUser()
  }, []);

  return (
    <Layout isAuthenticated={isAuthenticated}>
      <Routes>
        {GetAppRoutes(setIsAuthenticated, isAuthenticated, isAppLoading).map((route, index) => {
          const { element, requireAuth, ...rest } = route;
          return <Route key={index} 
            {...rest} 
            element={requireAuth ? <AuthorizeRoute {...rest} 
                                      isAuthenticated={isAuthenticated} 
                                      isAppLoading={isAppLoading} 
                                      element={element} /> 
                : element} />;
        })}
      </Routes>
      <ToastContainer />
    </Layout>
  );
}
